export const valueAsArrayOf = <T>(value: unknown): T[] | undefined => {
  if (!Array.isArray(value)) {
    return undefined;
  }

  // Assume value is a T[]
  return value as T[];
};
